import api from '@/api/'

export const strategyCommand = {
  async edit(data) {
    const res = await api.listTemplate(Object.assign({}, { state: 1, template_type: 1, line_id: data.line_id }))
    if (this.$validate(res)) {
      const { template } = res.data
    }
    if (Number(data.template_id)) {
      this.$router.push(`/article/template/${data.template_id}?id=${data.id}&line_id=${data.line_id}&type=1&status=${data.status}`,)
    } else {
      this.$router.push(`/article/edit/${data.id}?status=${data.status}`)
    }
  },
  async check(data, status) {
    const res = await api.updateCheckArticle({ id: data.id, status })
    if (this.$validate(res)) {
      this.$message.success('操作成功~')
      this.getList()
    }
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      async onOk() {
        const res = await api.deleteArticle({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
